export default {
  items: [
    {
      name: 'Logs',
      url: '/logs',
      icon: 'icon-layers',
    }
    /*,
    {
      name: 'Users',
      url: '/users',
      icon: 'icon-user',
    },
    */
  ]
};



// WEBPACK FOOTER //
// ./src/_nav.js